"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var JSXIcon = function JSXIcon(props) {
  var size = props.size,
      otherProps = _objectWithoutProperties(props, ["size"]);

  return (// -- START of generated SVG source.
    _react.default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: size,
      size: size
    }, otherProps, {
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: "10"
    }), _react.default.createElement("path", {
      d: "M19.522,3.851H11.315A3.723,3.723,0,0,0,15.02,7.556h1.512V9.015a3.723,3.723,0,0,0,3.7,3.7V4.563A.716.716,0,0,0,19.522,3.851Z"
    }), _react.default.createElement("path", {
      d: "M15.462,7.94H7.254a3.723,3.723,0,0,0,3.7,3.7h1.512v1.465a3.722,3.722,0,0,0,3.705,3.7V8.653A.716.716,0,0,0,15.462,7.94Z"
    }), _react.default.createElement("path", {
      d: "M11.4,12.028H3.191a3.722,3.722,0,0,0,3.705,3.7H8.413v1.46a3.723,3.723,0,0,0,3.7,3.7V12.739A.715.715,0,0,0,11.4,12.028Z"
    })) // -- END of generated content.

  );
};

JSXIcon.propTypes = {
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
JSXIcon.defaultProps = {
  size: 24
};
var _default = JSXIcon;
exports.default = _default;